import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeactivatePopupComponent } from './deactivate-popup.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [DeactivatePopupComponent],
  imports: [CommonModule,FormsModule],
  exports: [DeactivatePopupComponent],
})
export class DeactivatePopupModule {}
